import React, { useState } from 'react';
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import CollapsibleSection from '../../../../Core/CollapsibleSection/CollapsibleSection';
import VersionHistory from '../../../../utils/VersionHistory';

function Tab1({ fullDataState, activityboll, pack_slip }) {
  const [showActivity, setShowActivity] = useState(true);

  console.log(fullDataState, "fullDataState");
  const formatCreationDate = (datetime) => {
    if (!datetime) return '';
    return datetime.split(' ')[0]; 
  };

  return (
          <div
      className="row sidebarbox m-0"
      style={{
        padding: "8px",
        borderRadius: "5px",
        maxHeight: "74vh",
           minHeight: "74vh",
        overflowY: "scroll",
   
      }}
    >
        <div style={{     maxHeight: "74vh",}}>
      <div >
        <div className="d-flex gap-3" style={{marginBottom : '8px'}}>
          <div className="col">
            <Input
              id="orderNo"
              label="No"
              value={fullDataState?.name}
              style={{ height: '30px' }}
              readOnly
            />
          </div>
          <div className="col">
            <Input
              id="date"
              label="Order Date"
              value={formatCreationDate(fullDataState?.creation)}
              style={{ height: '30px' ,backgroundColor: '#f8f6f6'}}
              readOnly
            />
          </div>
        </div>
        <div  style={{marginBottom : '13px'}}>

        <Input
          id="delivery_note"
          label="Delivery Note"
          value={fullDataState?.delivery_note}
          readOnly
          style={{ height: '30px', }}
        />
        </div>

        <Input
          id="from_case_no"
          label="From Package No"
          value={fullDataState?.from_case_no}
          readOnly
          style={{ height: '30px',marginBottom : '12px' }}
          
        />

        <Input
          id="to_case_no"
          label="To Package No"
          value={fullDataState?.to_case_no}
          readOnly
          style={{ height: '30px', marginBottom : '12px' }}
        />
        <Input
          id="remarks"
          label="Remarks"
          value={fullDataState?.remarks}
          readOnly
          style={{ height: '30px', marginBottom : '12px'}}
        />

      </div>

      <div style={{  }}>

        <CollapsibleSection title="Package Weight Details">
          {/* Add content for Package Weight Details here */}
        </CollapsibleSection>

        <CollapsibleSection title="Letter Head">
          {/* Add content for Letter Head here */}
        </CollapsibleSection>

      </div>


      <div >
        <CollapsibleSection
          title="Activity"
          isOpen={showActivity}
          onToggle={() => setShowActivity(!showActivity)}
        >
          <VersionHistory
            doctype="Packing Slip"
            docname={pack_slip}
            activityboll={activityboll}
          />
        </CollapsibleSection>
      </div>
    </div>
        </div>

  );
}

export default Tab1;